module.exports = __webpack_public_path__ + "img/ic_32_register_mail.c28cdb41.svg";